import distance from "./distance";
import regex from "./regex";
import format from "../format";
/**
 * Get List Item for Id
 */
export const getListItemForId = (list: any, id: number) => {
    const index = list.byId[id];
    if (index == null) return {};
    return list.data[index];
};

/**
 * Get List Item Reducer
 * @description Update or add to state.data[] with item
 */
export const getListItemReducer = (state: any, item: any) => {
    const next = { ...state, item };
    const data = [...next.data]; // To remove object extensible creating a new object to eliminate this
    let index = next.byId[item.id];
    if (index == null) {
        index = next.data.length;
        next.byId[item.id] = index;
        data.push(item);
    } else {
        data[index] = item;
    }
    return { ...state, data: [...data] };
};

/**
 * Get List Reducer
 * @description Map data array to { byId, data }
 */
// Commenting this for now in case code below has issues, should be removed in the future
// export const getListReducer = (state: any, data: Array<any>) => ({
//   ...state,
//   byId: data.reduce((p: any, c: any, i: number) => ({ ...p, [c.id]: i }), {}),
//   data
// });

export const getListReducer = (state: any, data: Array<any>) => {
    let newById = {};
    data.forEach((item, index) => {
        newById[item.id] = index;
    });

    return {
        ...state,
        byId: newById,
        data
    };
};

/**
 * Google Maps <lat>,<lng> query URL
 */
/** Google maps url changed  to address */
export const googleMapsUrl = (address: string) =>
    `https://www.google.com/maps/search/?api=1&query=${address}`;

export const googleMapsSrcDesUrl = (
    srcLat: Number,
    srcLon: Number,
    desLat: Number,
    desLon: Number
) =>
    `https://www.google.com/maps/dir/?api=1&origin=${srcLat},${srcLon}&destination=${desLat},${desLon}&dirflag=w`;
/**
 * ID Name Map
 */
export const idNameMap = (data: Array<any>, prop: string) => {
    return data.reduce((byName, item) => {
        const next = byName;
        item[prop] && item[prop].forEach(({ name }) => (next[name] = item.id));
        return next;
    }, {});
};

/** Add to list reducer */
export const addListReducer = (state: any, data: Array<any>) => {
    const next = { ...state };
    let index = next.byId[data.id];
    if (!next.byId[data.id]) {
        index = next.data.length;
        next.byId[data.id] = index;
        next.data = [...next.data, data];
    }
    return next;
};

/**
 * Merge List Reducer
 * @description Merge state and data array to { byId, data }
 */
export const mergeListReducer = (state: any, data: Array<any>) => {
    const next = { ...state };
    data.forEach((item) => {
        let index = next.byId[item.id];
        if (index == null) {
            index = next.data.length;
            next.byId[item.id] = index;
            next.data = [...next.data, item];
        } else {
            next.data[index] = item;
        }
    });
    return next;
};
/** Updating existing  data to the store  */
export const updateListReducer = (state, item) => {
    const next = { ...state };
    next.data = next.data.map((list) => {
        if (list.id === item.id) {
            list = item;
        }
        return list;
    });
    return next;
};
/**
 * Name Join
 * @description Join [{ name }, { name }, ...] with delimiter
 * @param delimiter ';'
 */
export const nameJoin = (ref: Array<any>, delimiter: string = ";") =>
    (ref || []).map(({ name }) => name).join(delimiter);

/** Format date and time  */
const formatDate = (value, reqTime = true) => {
    if (reqTime)
        return `${format.date(value, "shortDate")} ${format.date(
            value,
            "time"
        )}`;
    else return `${format.date(value, "shortDate")}`;
};
/** Sort objects by date */
/**  Params
 * 1. Object to sort
 * 2. Key of the object
 * 3. type of sort  */
const sortByDate = (obj, dateKey, type) => {
    return obj.sort((a, b) => {
        const dateA = Date.parse(new Date(a[dateKey]));
        const dateB = Date.parse(new Date(b[dateKey]));
        if (type === "asc") {
            return dateA - dateB;
        } else if (type === "desc") {
            return dateB - dateA;
        } else {
            throw new Error('Invalid type. Use "asc" or "desc"');
        }
    });
};

/** Date Picker Configs*/
export const datePickerConfig = {
    format: "MMMM d, yyyy h:mm aa",
    minDate: new Date(),
    timeIntervals: 30,
    filterPassedTime: (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    }
};

export const removeTimeZone = (date) => {
    const utcDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();

    return utcDate.slice(0, -1);
};

export const mergeWithListData = (data, item) => {
    const newData = [...data];
    const index = newData.findIndex((i) => i.id === item.id);

    if (index > -1) {
        newData[index] = { ...newData[index], ...item };
    } else {
        newData.push(item);
    }

    return newData;
};

/**
 * Name Split
 * @description Split delimited string to [{ name }, { name }, ...]
 * @param delimiter ';'
 */
export const nameSplit = (ref: string, delimiter: string = ";") =>
    ref
        ? ref
              .toString()
              .split(delimiter)
              .map((name) => ({ name }))
        : [];

export { default as distance } from "./distance";
export { default as regex } from "./regex";
export default {
    distance,
    datePickerConfig,
    removeTimeZone,
    getListItemForId,
    getListItemReducer,
    getListReducer,
    googleMapsUrl,
    googleMapsSrcDesUrl,
    formatDate,
    idNameMap,
    addListReducer,
    mergeListReducer,
    mergeWithListData,
    nameJoin,
    nameSplit,
    regex,
    sortByDate,
    updateListReducer
};
